import { FormTimePicker, FormTimePickerProps } from '@britishcouncil/react-admin';
import { FieldPath, FieldValues, get, PathValue, useController } from 'react-hook-form';
import { RHFormFieldProps } from './types';

type RHFormTimePickerProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = RHFormFieldProps<FormTimePickerProps<string>, TFieldValues, TName> & {
  onChange?: (value: PathValue<TFieldValues, TName>) => void;
};

export const RHFormTimePicker = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  rules,
  shouldUnregister,
  defaultValue,
  onChange,
  ...props
}: RHFormTimePickerProps<TFieldValues, TName>) => {
  const { field, formState } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });

  const handleOnChange = (value: PathValue<TFieldValues, TName>) => {
    field.onChange(value);
    onChange?.(value);
  };

  return (
    <FormTimePicker
      {...props}
      name={name}
      value={field.value}
      onChange={handleOnChange}
      onBlur={field.onBlur}
      touched
      error={get(formState.errors, name)?.message}
    />
  );
};
